import AdminService from 'external-services/diary-admin-service';

const NS = 'SettingsCtrl';

export default function SettingsCtrl(
  $scope, $rootScope, $state, unregister
) {
  "ngInject";

  const vm = this;
  vm.venue = AdminService.getVenue();
  vm.enableFloorplanV2 = vm.venue.enableNewFloorPlan;

  //-- define public properties
  vm.title = 'Settings';
  vm.selectedPage = null;
  vm.diarySettings = [{
    name: 'Schedule',
    path: 'settings.schedule'
  }, {
    name: 'Events',
    path: 'settings.events'
  }, {
    name: 'Blockouts',
    path: 'settings.blockouts'
  }, {
    name: 'Booking Options',
    path: 'settings.menuoptions'
  }];
  vm.tableSettings = vm.enableFloorplanV2 ? [{
    name: 'Sections',
    path: 'settings.sections'
  }, {
    name: 'Layouts',
    path: 'settings.layouts'
  }, {
    name: 'Floor Plan',
    path: 'settings.floorplan'
  }, {
    name: 'Floor Plan Settings',
    path: 'settings.floorplansettings'
  }, {
    name: 'Section Groups',
    path: 'settings.sectiongroups'
  }, {
    name: 'Service Groups',
    path: 'settings.servicegroups'
  }] : [{
    name: 'Sections',
    path: 'settings.sections'
  }, {
    name: 'Layouts',
    path: 'settings.layouts'
  }, {
    name: 'Floor Plan',
    path: 'settings.floorplan'
  }, {
    name: 'Section Groups',
    path: 'settings.sectiongroups'
  }, {
    name: 'Service Groups',
    path: 'settings.servicegroups'
  }];
  vm.generalSettings = [{
    name: 'Status Options',
    path: 'settings.status'
  }, {
    name: 'Tags',
    path: 'settings.tags'
  }, {
    name: 'Bookings',
    path: 'settings.bookings'
  },
    {
      name: 'Maintenance',
      path: 'settings.maintenance'
    }
  ];
  //-- define public methods
  vm.openPage = openPage;

  var listeners = [];
  listeners.push($rootScope.$on('$stateChangeSuccess', checkSelected));
  listeners.push($scope.$on('$destroy', () => unregister(listeners)));

  checkSelected();

  function checkSelected() {
    if (vm.selectedPage) {
      vm.selectedPage.cls = '';
    }
    var pages = vm.diarySettings.concat(vm.tableSettings).concat(vm.generalSettings);
    // select the current page
    for (var page of pages) {
      if ($state.current.name.indexOf(page.path + ".") !== -1 || $state.current.name === page.path) {
        page.cls = 'selected';
        vm.selectedPage = page;
      }
    }
  }

  function openPage(page) {
    $state.go(page.path);
  }
}
